import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

import { TypedStoreConfig } from '../factories/store';

import AccountModel from './models/account-model';
import BillingModel from './models/billing-model';
import DocumentModel from './models/document-model';
import NotificationsModel from './models/notifications-model';
import ProfileModel from './models/profile-model';
import PublicationsModel from './models/publication-model';
import RelatedEntityModel from './models/related-entity-model';
import SubscriptionsModel from './models/subscription-model';
import TransactionModel from './models/transaction-model';

export const UserAccountModel = TypedStoreConfig({
    modelName: 'UserAccountModel',
    properties: {
        account: types.maybeNull(types.optional(AccountModel, {})),
        billing: types.maybeNull(types.array(BillingModel)),
        documents: types.maybeNull(types.array(DocumentModel)),
        hasFullProfile: types.maybeNull(types.maybeNull(types.boolean)),
        notifications: types.maybeNull(types.maybeNull(NotificationsModel)),
        profile: types.optional(ProfileModel, {}),
        publications: types.maybeNull(types.maybeNull(PublicationsModel)),
        relatedEntities: types.maybeNull(types.array(RelatedEntityModel)),
        subscriptions: types.maybeNull(types.maybeNull(SubscriptionsModel)),
        transactionHistory: types.maybeNull(types.array(TransactionModel)),
    },
})
    .actions((self) => ({
        getActiveSubscriptions() {
            console.log('self.subscriptions :  ', self.subscriptions);
            console.log('         purchases :  ', self.subscriptions?.purchases);
            if (!self.subscriptions) {
                return [];
            }
            return self.subscriptions.purchases.filter((p) => {
                const isActive = p.status == 'Active';
                return isActive && p.isCancellable;
            });
        },
    }))
    .actions((self) => ({
        hasPaidSubscriptions() {
            return self.getActiveSubscriptions().length > 0;
        },
    }));

export type TypeUserAccountModel = Instance<typeof UserAccountModel>;
export default UserAccountModel;
